export default {
    'confirm_delete': 'Are you sure to delete this data?',
    'success_delete': 'Successed delete data',
    'error_delete': 'Failed delete data',

    'confirm_update': 'Are you sure to update this data?',
    'success_update': 'Successed update data',
    'error_update': 'Failed update data',

    'confirm_close': 'Are you sure to close this data?',
    'success_close': 'Successed close data',
    'error_close': 'Failed close data',

    'confirm_send': 'Are you sure to send this data?',
    'success_send': 'Successed send data',
    'error_send': 'Failed send data',

    'confirm_default': 'Are you sure to default this data?',
    'success_default': 'Successed default data',
    'error_default': 'Failed default data',

    'confirm_move_file': 'Are you sure you want to move this file here',

    'confirm_synchron': 'Are you sure to synchron this data?',
    'success_synchron': 'Successed synchron data',
    'error_synchron': 'Failed synchron data',

    'confirm_process': 'Are you sure to process this data?',
    'confirm_copy': 'The data that has been filled in will be overwritten',

    'confirm_save' : 'Are you sure to save this data?',

    'success_login': 'Welcome :name',
    'error_username_password_required': 'Username and Password can\'t empty',
    'error_unauthorization': 'You don\'t have permission to this page',

    'home': 'Home',

    'login': 'Login',
    'please_login': 'Please Login',
    'username': 'Username',
    'password': 'Password',
    'forgot_password': 'Forgot Password ?',
    'reset_password': 'Reset Password',
    'please_wait': 'Please Wait',

    'material_type': 'Material Type',
    'm_type': 'M Type',
    'maintenance_status': 'Maintenance Status',
    'account_category_refference': 'Account Category Refference',
    'add_material_type': 'Add Material Type',
    'edit_material_type': 'Edit Material Type',
    'relation': 'Relation',
    'create_relation': 'Create Relation',
    'search_material_type': 'Search Material Type',
    'choose_account_catalog_refference': 'Choose Account Catalog Refference',
    'choose_account_category_refference': 'Choose Account Category Refference',
    'choose_price_control': 'Choose Price Control',

    'search_material_group': 'Search Material Group',
    'purchasing_group': 'Purchasing Group',
    'add_material_group': 'Add Material Group',
    'edit_material_group': 'Edit Material Group',
    'choose_holding': 'Choose Holding',
    'choose_client': 'Choose Client',
    'choose_purchasing_group': 'Choose Purchasing Group',

    'search_service_category': 'Search Service Category',
    'add_service_category': 'Add Service Category',
    'edit_service_category': 'Edit Service Category',

    'search_service_group': 'Search Service Group',
    'add_service_group': 'Add Service Group',
    'edit_service_group': 'Edit Service Group',

    'client': 'Client',
    'search_client': 'Search Client',
    'client_code': 'Client Code',
    'client_name': 'Client Name',
    'add_holding_code': 'Add Holding Code',
    'edit_holding_code': 'Edit Holding Code',

    'company_code': 'Company Code',
    'search_company_code': 'Search Company Code',
    'company_description': 'Company Description',
    'add_company_code': 'Add Company Code',
    'edit_company_code': 'Edit Company Code',

    'search_plant_code': 'Search Plant Code',
    'city': 'City',
    'address': 'Address',
    'po_box': 'PO Box',
    'postal_code': 'Postal Code',
    'add_plant_code': 'Add Plant Code',
    'edit_plant_code': 'Edit Plant Code',
    'choose_company': 'Choose Company',
    'choose_profit_center': 'Choose Profit Center',

    'search_plant_sp': 'Search Plant SP',
    'add_plant_sp': 'Add Plant SP',
    'edit_plant_sp': 'Edit Plant SP',

    'search_location_code': 'Search Location Code',
    'location_description': 'Location Description',
    'add_location_code': 'Add Location Code',
    'edit_location_code': 'Edit Location Code',
    'choose_plant': 'Choose Plant',
    'choose_material_group': 'Choose Material Group',
    'choose_manufacture': 'Choose Manufacture',

    'search_valuation_class': 'Search Valuation Class',
    'add_valuation_class': 'Add Valuation Class',
    'edit_valuation_class': 'Edit Valuation Class',

    'search_catalog_status': 'Search Catalog Status',
    'add_catalog_status': 'Add Catalog Status',
    'edit_catalog_status': 'Edit Catalog Status',
    'choose_type': 'Choose Type',

    'search_catalog_type': 'Search Catalog Type',
    'add_catalog_type': 'Add Catalog Type',
    'edit_catalog_type': 'Edit Catalog Type',
    'choose_catatalog_type': 'Choose Catalog Type',

    'search_equipment_code': 'Search Equipment Code',
    'add_equipment_code': 'Add Equipment Code',
    'edit_equipment_code': 'Edit Equipment Code',
    'equipment_description': 'Equipment Description',
    'serial_number': 'Serial Number',
    'additional_data': 'Additional Data',
    'sm_manufacturer': 'Manufacturer',

    'search_manref_type': 'Search Manref Type',
    'add_manref_type': 'Add Manref Type',
    'edit_manref_type': 'Edit Manref Type',

    'search_source_type': 'Search Source Type',
    'choose_source_type': 'Choose Source Type',
    'add_source_type': 'Add Source Type',
    'edit_source_type': 'Edit Source Type',

    'search_sales_organization': 'Search Sales Organization',
    'add_sales_organization': 'Add Sales Organization',
    'edit_sales_organization': 'Edit Sales Organization',
    'sales_organization': 'Sales Organization',

    'search_distribution_channel': 'Search Distribution Channel',
    'add_distribution_channel': 'Add Distribution Channel',
    'edit_distribution_channel': 'Edit Distribution Channel',
    'distribution_channel': 'Distribution Channel',
    'sales_unit': 'Sales Unit',
    'distr_channel': 'Distr Channel',

    'search_warehouse': 'Search Warehouse',
    'add_warehouse': 'Add Warehouse',
    'edit_warehouse': 'Edit Warehouse',
    'warehouse': 'Warehouse',
    'warehouse_number': 'Warehouse No',

    'search_account_assignment_group': 'Search Account Assignment Group',
    'add_account_assignment_group': 'Add Account Assignment Group',
    'edit_account_assignment_group': 'Edit Account Assignment Group',

    'search_product_hierarchy': 'Search Product Hierarchy',
    'add_product_hierarchy': 'Add Product Hierarchy',
    'edit_product_hierarchy': 'Edit Product Hierarchy',
    'level': 'Level',

    'search_profit_center': 'Search Profit Center',
    'add_profit_center': 'Add Profit Center',
    'edit_profit_center': 'Edit Profit Center',

    'search_price_control': 'Search Price Control',
    'add_price_control': 'Add Price Control',
    'edit_price_control': 'Edit Price Control',

    'search_purchasing_group': 'Search Purchasing Group',
    'add_purchasing_group': 'Add Purchasing Group',
    'edit_purchasing_group': 'Edit Purchasing Group',

    'search_account_category_refference': 'Search Account Category Refference',
    'add_account_category_refference': 'Add Account Category Refference',
    'edit_account_category_refference': 'Edit Account Category Refference',

    'approval_list': 'Approval List',
    'approval_page': 'Approval Page',
    'revision': 'Revision',
    'created_by': 'Created By',
    'total_item': 'Total Item',
    'workflow_status': 'Workflow Status',
    'approval': 'Approval',
    'approval_page': 'Approval Page',
    'mcr_information': 'MCR Information',
    'mcr_item': 'MCR Item',
    'mcr_item_note': 'MCR Item Note',
    'tracking': 'Tracking',
    'approve': 'Approve',
    'approval_tracking': 'Approval Tracking',
    'approver': 'Approver',
    'reject_mcr': 'Reject MCR',

    'draft_list': 'Draft List',
    'basic_data_&_specification': 'Basic Data & Specification',
    'fabric_or_non_fabrication': ' Fabric/Non Fabrication',
    'bom_or_non_bom': 'Bom/Non Bom Equipment',
    'specification': 'Specification',
    'manufacturer_part_number': 'Manufacturer Part Number',
    'manufacturer_code': 'Manufacturer Code',
    'mpn': 'MPN',
    'mcr_subject': 'MCR Subject',
    'edit_subject': 'Edit Subject',
    'reason': 'Reason',
    'consolidate_from': 'Consolidate From',
    'consolidate_to': 'Consolidate To',
    'equipment_&_quantity_install': 'Equipment & Quantity Install',
    'qty_install': 'Qty Install',
    'attachment_document': 'Attachment Document',
    'up_attachment_document': 'ATTACHMENT DOCUMENT',
    'attachment_mcr_number': 'ATTACHMENT & MCR NO',
    'file_type': 'File Type',
    'choose_item_name': 'Choose Item Name',
    'choose_item_type': 'Choose Item Type',
    'choose_fabric_or_non_fabrication': 'Choose Fabric/Non Fabrication',
    'choose_bom_or_non_bom': 'Choose Bom/Non Bom',
    'change_material': 'Change Material',
    'client_level': 'Client Level',
    'plant_level': 'Plant Level',
    'minimum_stock': 'Minimum Stock',
    'mrp_type': 'MRP Type',
    'reorder_point': 'Reorder Point',
    'maximum_stock': 'Maximum Stock',
    'extend_material': 'Extend Material',
    'deletion_flag_material': 'Deletion Flag Material',
    'valuation_type': 'Valuation Type',
    'valuation_area': 'Valuation Area',
    'choose_valuation_area': 'Choose Valuation Area',
    'val_type': 'Val Type',
    'storage_type': 'Storage Type',
    'value_view': 'Value View',
    'po_text_memo': 'PO Text Memo',
    'sales': 'Sales',
    'up_sales': 'SALES',
    'sales_org': 'Sales Org',
    'division': 'Division',
    'search_division': 'Search Division',
    'search_tax_class': 'Search Tax Classification',
    'search_gen_item_cat_grp': 'Gen. Item Cat. Grp.',
    'search_item_cat_grp': 'Search Item Category Group',
    'search_trans_group': 'Search Transportation Group',
    'tax_cat': 'Tax Cat',
    'tax_class': 'Tax Class',
    'gen_item_cat_grp': 'Gen Item Cat Grp',
    'account_assign_grp': 'Acc Assign Grp',
    'item_cat_grp': 'Item Cat Grp',
    'trans_group': 'Trans Group',
    'loading_group': 'Loading Group',
    'mrp': 'MRP',
    'mrp_controller': 'MRP Controller',
    'search_mrp_controller': 'Search MRP Controller',
    'mrp_types': 'MRP Types',
    'search_mrp_types': 'Search MRP Types',
    'lot_size': 'Lot Size',
    'max_stock': 'Max Stock',
    'fixed_lot': 'Fixed Lot Size',
    'ord_costs': 'Ord Costs',
    'search_lot_size': 'Ord Costs',
    'min': 'Min Lot Size',
    'max': 'Max Lot Size',
    'procurement_type': 'Procurement Type',
    'special_proc': 'Special Proc',
    'choose_special_proc': 'Choose Special Proc',
    'valuation_category': 'Valuation Category',
    'val_category': 'Val Category',
    'price_determination': 'Price Determination',
    'price_determ': 'Price Determ',
    'quantity_install': 'Quantity Install',
    'material_asal': 'Material Asal',
    'deletion_type': 'Deletion Type',
    'choose_deletion_type': 'Choose Deletion Type',
    'material_number_tujuan': 'Material Tujuan',
    'choose_level': 'Choose Level',
    'create_new_material': 'Create New Material',
    'scope_of_supply': 'Scope of Supply',
    'up_sos': 'SOS',
    'add_scope_of_supply': 'Add Scope of Supply',
    'edit_scope_of_supply': 'Edit Scope of Supply',
    'search_sos': 'Search SOS',
    'sos_header': 'SOS Header',
    'sos_description': 'SOS Description',
    'drawing_number': 'Drawing Number',
    'choose_material_number': 'Choose Material Number',
    'choose_abc_indicator': 'Choose ABC Indicator',
    'choose_mrp_type': 'Choose MRP Type',
    'choose_mrp_controller': 'Choose MRP Controller',
    'choose_storage_location': 'Choose Storage Location',
    'choose_bin_location': 'Choose Bin Location',
    'choose_valuation_type': 'Choose Valuation Type',
    'choose_client_level_or_plant_level': 'Choose Client Level/Plant Level',
    'choose_sales_organization': 'Choose Sales Organization',
    'choose_distribution_channel': 'Choose Distribution Channel',
    'choose_warehouse_number': 'Choose Warehouse Number',
    'choose_storage_type': 'Choose Storage Type',
    'choose_critical_non_critical': 'Choose Critical/Non Critical',
    'choose_spc_proc_type': 'Choose Special Proc Type',
    'choose_price_determination': 'Choose Price Determination',
    'critical_non_critical': 'Critical/Non Critical',


    'material_request_list': 'Material Request List',
    'filter': 'Filter',
    'add_new_mcr': 'Add New MCR',
    'choose_status': 'Choose Status',
    'choose_workflow_status': 'Choose Workflow Status',
    'choose_catalog_type': 'Choose Catalog Type',
    'choose_approval_status': 'Choose Approval Status',
    'mcr_form_detail': 'MCR FORM DETAIL',
    'mcr_form': 'MCR FORM',
    'mcr_approval': 'MCR APPROVAL',
    'material_list': 'Material List',
    'send': 'Send',
    'add_new_item': 'Add New Item',
    'detail_material': 'Detail Material',
    'type_model_part_number': 'Type/Model/Part Number',
    'attachment_of_material': 'Attachment of Material',
    'attachment': 'Attachment',
    'choose_attachment': 'Choose Attachment',
    'form_service_request': 'Form Service Request',
    'parameter': 'Parameter',
    'colloquial_name': 'Colloquial Name',
    'characteristic_value': 'Characteristic Value',
    'short_description_format_&_sequence': 'Short Description Format & Sequence',
    'master_drawing': 'Master Drawing',
    'action_date_range': 'Action Date Range',
    'barang_umum_non_suku_cadang': 'Barang Umum / Non Suku Cadang',



    'service_list': 'Service List',
    'choose_service_category': 'Choose Service Category',
    'choose_service_group': 'Choose Service Group',
    'choose_unit_of_measure': 'Choose Unit of Measure',
    'choose_valuation_class': 'Choose Valuation Class',

    'standard_item_name': 'Standard Item Name',
    'group_definition': 'Group Definition',
    'search_item_name': 'Search Item Name',
    'image': 'Image',
    'generate': 'Generate',
    'short_name': 'Short Name',
    'add_new_colloquial': 'Add New Colloquial',
    'add_new_group_class': 'Add New Group Class',
    'add_new_material_type': 'Add New Material Type',
    'add_new_material_group': 'Add New Material Group',
    'add_new_service_category': 'Add New Service Category',
    'add_new_service_group': 'Add New Service Group',
    'add_new_image_item_name': 'Add New Image Item Name',

    'characteristic': 'Characteristic',
    'char_sap': 'Characteristic SAP',
    'char_value': 'Char Value',
    'master_type': 'Master Type',
    'abbrev': 'Abbrev',
    'add_item_name': 'Add Item Name',
    'sample_answer': 'Sample Answer',
    'abbreviation': 'Abbreviation',
    'search_inc_item_name': 'Search INC / Item Name',
    'search_sample_answer': 'Search Sample Answer',
    'choose_approval': 'Choose Approval',
    'choose_inc': 'Choose INC',
    'choose_characteristic_master': 'Choose Characteristic Master',
    'current_value': 'Current Value',
    'update_to': 'Update To',
    'abbreviation_to': 'Abbreviation To',
    'edit_characteristic_value': 'Edit Characteristic Value',
    'sequence': 'Sequence',
    'seq_shortdes': 'Seq Shortdes',
    'separator': 'Separator',
    'choose_separator': 'Choose Separator',
    'is_mandatory': 'Mandatory ?',
    'choose_is_mandatory': 'Is This Item Mandatory?',

    'characteristic_master': 'Characteristic Master',
    'search_characteristic': 'Search Characteristic',
    'add_characteristic': 'Add Characteristic',
    'single_multiple': 'Single/Multiple',
    'label': 'Label',
    'position_of_label': 'Position of Label',
    'space': 'Space',
    'add_characteristic_master': 'Add Characteristic Master',
    'edit_characteristic_master': 'Edit Characteristic Master',
    'search_characteristic_master': 'Search Characteristic Master',
    'position': 'Position',
    'choose_single_multiple': 'Choose Single Multiple',
    'choose_position': 'Choose Position',
    'choose_space': 'Choose Space',

    'search_unit_of_measure': 'Search Unit of Measure',
    'add_uom': 'Add UOM',
    'edit_uom': 'Edit UOM',

    'search_abbreviation': 'Search Abbreviation',
    'add_abbreviation': 'Add Abbreviation',
    'edit_abbreviation': 'Edit Abbreviation',

    'search_manufacture': 'Search Manufacture',
    'add_manufacture': 'Add Manufacture',
    'edit_manufacture': 'Edit Manufacture',
    'country': 'Country',
    'business_type': 'Business Type',
    'phone': 'Phone',
    'fax': 'Fax',
    'mobile_phone': 'Mobile Phone',
    'contact_person': 'Contact Person',
    'manufacture_name': 'Manufacture Name',

    'ngc': 'NGC',
    'search_nato': 'Search Nato',
    'please_search_to_show_data': 'Please Search To Show Data',
    'definition': 'Definition',
    'english': 'English',
    'indonesia': 'Indonesia',
    'main_group': 'Main Group',

    'add_nato': 'Add Nato',
    'edit_nato': 'Edit Nato',
    'nsc': 'NSC',
    'description': 'Description',
    'english_definition': 'English Definition',
    'indonesia_definition': 'Indonesia Definition',
    'close': 'Close',
    'add': 'Add',

    'smartcat_attachment': 'SmartCat Attachment',
    'search_attachment': 'Search Attachment',
    'name': 'Name',
    'upload_by': 'Upload By',
    'date': 'Date',
    'size': 'Size',
    'rename': 'Rename',
    'delete': 'Delete',
    'move_to': 'Move To',
    'add_new': 'Add New',
    'new_folder': 'New Folder',
    'new_file': 'New File',
    'new_link': 'New Link',
    'link_name': 'Link',
    'add_new_link': 'Add New Link',
    'add_new_folder': 'Add New Folder',
    'folder_name': 'Folder Name',
    'upload_files': 'Upload Files',
    'file_name': 'File Name',
    'file_name_option': 'File Name Option',
    'upload': 'Upload',
    'cancle': 'Cancle',
    'rename_folder_name': 'Rename Folder Name',
    'edit': 'Edit',
    'freetext': 'Freetext',
    'oem': 'OEM',
    'general': 'General',
    'equipment_name': 'Equipment Name',
    'manufacture_code': 'Manufacture Code',
    'model_or_type': 'Model/Type',
    'part_number_or_drawing': 'Part Number/Drawing',
    'inc': 'INC',
    'mfr_code': 'MFR Code',
    'manref': 'Manref',
    'mfr_ref': 'MFR Ref',
    'rename_file': 'Rename File',
    'choose_file': 'Choose File',
    'drawing_master': 'Drawing Master',
    'search_drawing_master': 'Search Drawing Master',
    'drawing_name': 'Drawing Name',
    'drawing_number': 'Drawing Number',
    'date': 'Date',
    'add_new_drawing_master': 'Add New Drawing Master',
    'choose_equipment': 'Choose Equipment',
    'choose_drawing_number': 'Choose Drawing Number',
    'choose_company': 'Choose Company',

    'compose_message': 'Compose Message',
    'from': 'From',
    'to': 'To',
    'subject': 'Subject',
    'send_message': 'Send Message',
    'choose_to': 'Choose To',

    'inbox': 'Inbox',

    'sent': 'Sent',
    'search_message': 'Search Message',
    'sender': 'Sender',
    'message': 'Message',
    'view': 'View',
    'detail_message': 'Detail Message',
    'reply_message': 'Reply Message',
    'reply': 'Reply',

    'sap_connection': 'Sap Connection',
    'search_sap_connection': 'Search Sap Connection',
    'connection': 'Connection',
    'url': 'Url',
    'client': 'Client',
    'status': 'Status',
    'default': 'Default',
    'add_sap_connection': 'Add Sap Connection',
    'edit_sap_connection': 'Edit Sap Connection',
    'reset': 'Reset',
    'code': 'Code',
    'sap_sync_id': 'Sap Sync Id',
    'connection_id': 'Connection Id',
    'key': 'Key',
    'done_at': 'Done At',

    'master_data_synchron': 'Master Data Synchron',
    'search_master_data_synchron': 'Search Master Data Synchron',
    'table': 'Table',
    'data': 'Data',
    'function': 'Function',
    'input': 'Input',
    'output': 'Output',
    'synchron': 'Synchron',
    'add_master_data_synchron': 'Add Master Data Synchron',
    'edit_master_data_synchron': 'Edit Master Data Synchron',

    'sap_synchron_task': 'SAP Synchron Task',
    'search_sap_synchron_task': 'Search SAP Synchron Task',
    'mcr_number': 'MCR Number',
    'type': 'Type',
    'requested_by': 'Requested By',
    'requested_at': 'Requested At',
    'executed_at': 'Executed At',
    'view_log': 'Log',
    'synchron_task_log': 'Synchron Task Log',
    'number': 'Number',
    'edit_sap_synchron_task': 'Edit SAP Synchron Task',
    'sap_sync_task_id': 'Sap Sync Task Id',
    're_synchron': 'Re-sync',

    'account_list': 'Account List',
    'search_account': 'Search Account',
    'role': 'Role',
    'choose_role': 'Choose Role',
    'cat_type': 'Cat Type',
    'email': 'Email',
    'client': 'Client',
    'company': 'Company',
    'create_new_account': 'Create New Account',
    'user_information': 'User Information',
    'email_address': 'Email Address',
    'first_name': 'First Name',
    'last_name': 'Last Name',
    'jabatan': 'Jabatan',
    'catalog_type': 'Catalog Type',
    'other_information': 'Other Information',
    'roles': 'Roles',
    'search_roles': 'Search Roles',
    'structure_information': 'Structure Information',
    'department': 'Department',
    'section': 'Section',
    'sub_section': 'Sub Section',
    'password_confirmation': 'Password Confirmation',
    'update_account': 'Update Account',
    'change_status': 'Change Status',
    'save_changes': 'Save Changes',
    'save': 'Save',
    'update': 'Update',
    'edit_account': 'Edit Account',
    'delete_account': 'Delete Account',
    'add_sap_synchron_task': 'Add SAP Synchron Task',
    'choose_roles': 'Choose Roles',
    'choose_department': 'Choose Department',
    'choose_section': 'Choose Section',
    'choose_sub_section': 'Choose Sub Section',
    'choose_jabatan': 'Choose Jabatan',

    'search_jabatan': 'Search Jabatan',
    'add_jabatan': 'Add Jabatan',
    'edit_jabatan': 'Edit Jabatan',

    'no': 'No',
    'edit_role': 'Edit Role',
    'create_new_role': 'Create New Role',
    'update_role': 'Update Role',
    'create': 'Create',
    'role_name': 'Role Name',
    'dashboard': 'Dashboard',
    'my_work': 'My Work',
    'view_detail_cataloged': 'View Detail Cataloged',
    'view_chart_cataloged': 'View Chart Cataloged',
    'view_summary_mcr': 'View Summary MCR',
    'view_detail_mcr': 'View Detail MCR',
    'view_dashboard_my_work': 'View Dashboard My Work',
    'view_detail_kpi_cataloger': 'View Detail KPI Cataloger',
    'view_summary_catalog_status': 'View Summary Catalog Status',
    'view_online_user': 'View Online User',
    'view_summary_work_approval': 'View Summary Work Approval',
    'dictionary': 'Dictionary',
    'delete_sample': 'Delete Sample',
    'characteristic_item_name': 'Characteristic Item Name',
    'add_char_item_name': 'Add Characteristic Item Name',
    'add_char_value': 'Add Characteristic Value',
    'update_sequence_shortdes': 'Update Sequence Shortdes',
    'create_sample': 'Create Sample',
    'update_sample': 'Update Sample',
    'colloquial': 'Colloquial',
    'create_colloquial': 'Create Colloquial',
    'delete_image': 'Delete Image',
    'delete_material_group': 'Delete Material Group',
    'create_service_group': 'Create Service Group',
    'create_group_class': 'Create Group Class',
    'create_material_type': 'Create Material Type',
    'delete_colloquial': 'Delete Colloquial',
    'delete_service_group': 'Delete Service Group',
    'delete_group_class': 'Delete Group Class',
    'delete_material_type': 'Delete Material Type',
    'create_service_category': 'Create Service Category',
    'create_image': 'Create Image',
    'create_material_group': 'Create Material Group',
    'delete_service_category': 'Delete Service Category',
    'general_master_data': 'General Master Data',
    'account_assignment_group': 'Account Assignment Group',
    'bin_code': 'Bin Code',
    'harmonized_code': 'Harmonized Code',
    'hazard_code': 'Hazard Code',
    'delete_relation': 'Delete Relation',
    'general_setting': 'General Setting',
    'holding_configuration': 'Holding Configuration',
    'manage_menu': 'Manage Menu',
    'self_code': 'Self Code',
    'manage_sub_menu': 'Manage Sub Menu',
    'manage_account': 'Manage Account',
    'manage_permission': 'Manage Permission',
    'choose_sub_menu': 'Choose Sub Menu',
    'manage_role': 'Manage Role',
    'search_role': 'Search Role',
    'material': 'Material',
    'service_catalog_request': 'Service Catalog Request',
    'approval_list_view': 'Approval List View',
    'approval_name': 'Approval Name',
    'approver_1': 'Approver 1',
    'approver_2': 'Approver 2',
    'approver_3': 'Approver 3',
    'approver_4': 'Approver 4',
    'approver_5': 'Approver 5',
    'approver_6': 'Approver 6',
    'approver_7': 'Approver 7',
    'approve_mcr': 'Approve MCR',
    'material_request': 'Material Request',
    'service_request': 'Service Request',
    'material_master': 'Material Master',
    'create_material': 'Create Material',
    'multiple_view': 'Multiple View',
    'duplicate': 'Duplicate',
    'copy_value': 'Copy Value',
    'create_weblink': 'Create Weblink',
    'change_view_description': 'Change View Description',
    'delete_manufacture': 'Delete Manufacture',
    'update_material_type': 'Update Material Type',
    'update_industry_sector': 'Update Industry Sector',
    'update_weight_unit': 'Update Weight Unit',
    'delete_keyword': 'Delete Keyword',
    'create_plant': 'Create Plant',
    'update_detail_material': 'Update Detail Material',
    'update_purchasing_group': 'Update Purchasing Group',
    'delete_accounting': 'Delete Accounting',
    'delete_pdf': 'Delete PDF',
    'characteristic_name': 'Characteristic Name',
    'update_material_group': 'Update Material Group',
    'update_stock_type': 'Update Stock Type',
    'update_catalog_type': 'Update Catalog Type',
    'create_equipment': 'Create Equipment',
    'update_plant': 'Update Plant',
    'delete_purchasing': 'Delete Purchasing',
    'update_abc_indicator': 'Update ABC Indicator',
    'delete_weblink': 'Delete Weblink',
    'create_manufacture': 'Create Manufacture',
    'update_item_type': 'Update Item Type',
    'update_uom': 'Updat UOM',
    'update_soh': 'Update SOH',
    'update_note': 'Update Note',
    'update_equipment': 'Update Equipment',
    'delete_plant': 'Delete Plant',
    'update_batch_management': 'Update Batch Management',
    'create_accounting': 'Create Accounting',
    'update_old_material_number': 'Update Old Material Number',
    'verified': 'Verified',
    'approved': 'Approved',
    'update_weblink': 'Update Weblink',
    'update_description': 'Update Description',
    'update_manufacture': 'Update Manufacture',
    'update_group_class': 'Update Group Class',
    'update_product_hierarchy': 'Update Product Hierarchy',
    'update_weight_value': 'Update Weight Value',
    'create_keyword': 'Create Keyword',
    'delete_equipment': 'Delete Equipment',
    'create_pdf': 'Create PDF',
    'create_purchasing_group': 'Create Purchasing Group',
    'update_accounting': 'Update Accounting',
    'update_ext_material_group': 'Update Ext Material Group',
    'raw_data': 'Raw Data',
    'save_workbench': 'Save Workbench',
    'catalogued': 'Catalogued',
    'cataloguer_name': 'Cataloguer Name',
    'not_yet_complete': 'Not Yet Complete',
    'new_mcr': 'New MCR',
    'quality_assurance': 'Quality Assurance',
    'obsolete': 'Obsolete',
    'stored_in_sap': 'Stored in SAP',
    'single_view': 'Single View',
    'compose': 'Compose',
    'view_inbox': 'View Inbox',
    'view_sent': 'View Sent',
    'report': 'Report',
    'create_report': 'Create Report',
    'generate_barcode': 'Generate Barcode',
    'update_table': 'Update Table',
    'check_duplicate': 'Check Duplicate',
    'by_description': 'By Description',
    'by_part_number': 'By Part Number',
    'sap_configuration': 'SAP Configuration',
    'master_data_configuration': 'Master Data Configuration',
    'change_default': 'Change Default',
    'service_master': 'Service Master',
    'create_keyboard': 'Create Keyboard',
    'create_multiple': 'Create Multiple',
    'update_valuation_class': 'Update Valuation Class',
    'delete_keyboard': 'Delete Keyboard',
    'update_detail_service': 'Update Detail Service',
    'update_service_category': 'Update Service Category',
    'update_item_name': 'Update Item Name',
    'update_service_group': 'Update Service Group',
    'choose_group_class': 'Choose Group Class',
    'choose_material_type': 'Choose Material Type',
    'special_procurement_type': 'Special Procurement Type',
    'search_special_procurement_type': 'Search Special Procurement Type',
    'procurement_type': 'Procurement Type',
    'search_procurement_type': 'Search Procurement Type',
    'loading_group': 'Loading Group',
    'search_loading_group': 'Search Loading Group',

    'permission': 'Permission',
    'search_permission': 'Search Permission',
    'menu': 'Menu',
    'sub_menu': 'Sub Menu',
    'guard_name': 'Guard Name',
    'create_new_permission': 'Create New Permission',
    'update_permission': 'Update Permission',

    'search_department': 'Search Department',
    'add_department': 'Add Department',
    'edit_department': 'Edit Department',

    'search_section': 'Search Section',
    'add_section': 'Add Section',
    'edit_section': 'Edit Section',

    'search_sub_section': 'Search Sub Section',
    'add_sub_section': 'Add Sub Section',
    'edit_sub_section': 'Edit Sub Section',

    'search_menu': 'Search Menu',
    'create_new_menu': 'Create New Menu',
    'update_menu': 'Update Menu',
    'choose_menu': 'Choose Menu',

    'search_sub_menu': 'Search Sub Menu',
    'create_new_sub_menu': 'Create New Sub Menu',
    'update_sub_menu': 'Update Sub Menu',

    'mail_config': 'Mail Configuration',
    'driver': 'Driver',
    'host': 'Host',
    'port': 'Port',
    'from_address': 'From Address',
    'from_name': 'From Name',
    'encryption': 'Encryption',
    'sendmail': 'Sendmail',
    'connection_test': 'Connection Test',

    'notification_master': 'Notification Master',
    'search_notification_master': 'Search Notification Master',
    'url': 'URL',
    'send_mail': 'Send Mail',
    'recipient': 'Recipient',
    'add_notification_master': 'Add Notification Master',
    'edit_notification_master': 'Edit Notification Master',

    'mcr_avg_duration': 'MCR Duration AVG',
    'view_by': 'View By',
    'per_mcr': 'Per MCR',
    'per_company': 'Per Company',
    'per_jabatan': 'Per Position',
    'avg_duration': 'Average Duration',
    'total_approval_actions': 'Total Approval Actions',
    'no_data': 'No data available',

    'mcr_status': 'MCR Status',
    'search_mcr_status': 'Search MCR Status',
    'add_mcr_status': 'Add MCR Status',
    'edit_mcr_status': 'Edit MCR Status',

    'faq': 'FAQ',
    'search_faq': 'Search FAQ',
    'question': 'Question',
    'answer': 'Answer',
    'detail': 'Detail',
    'detail_or_preview': 'Detail/Preview',
    'add_faq': 'Add FAQ',
    'update_faq': 'Update FAQ',
    'detail_faq': 'Detail FAQ',

    'database_backup': 'Database Backup',
    'backup_name': 'Backup Name',
    'backup_time': 'Backup Time',
    'backup_path': 'Backup Path',
    'backup_maximum_of_files': 'Backup Maximum Of Files',

    'mail_templates': 'Mail Templates',
    'search_mail_templates': 'Search Mail Templates',
    'source_type': 'Source Type',
    'source': 'Source',
    'template_type': 'Template Type',
    'template': 'Template',
    'add_mail_templates': 'Add Mail Templates',
    'edit_mail_templates': 'Edit Mail Templates',
    'plain_text': 'Plain Text',
    'script': 'Script',
    'choose_source': 'Choose Source',

    'tasks': 'Tasks',
    'search_tasks': 'Search Tasks',
    'task': 'Task',
    'add_task': 'Add Task',
    'edit_task': 'Edit Task',
    'choose_task': 'Choose Task',
    'view_target': 'View Target',
    'view_url': 'View Url',
    'process_target': 'Process Target',
    'process_url': 'Process Url',
    'duration': 'Duration',

    'task_menus': 'Task Menus',
    'search_task_menus': 'Search Task Menus',
    'update_sequence': 'Update Sequence',
    'add_task_menus': 'Add Task Menus',
    'edit_task_menus': 'Edit Task Menus',
    'symbol': 'Symbol',
    'attributes': 'Attributes',
    'icon': 'Icon',

    'workflows': 'Workflows',
    'search_workflows': 'Search Workflows',
    'add_workflows': 'Add Workflows',
    'setting_workflows': 'Setting Workflows',
    'preview_parameter': 'Preview Parameter',
    'preview': 'Preview',
    'condition': 'Condition',
    'add_condition': 'Add Condition',
    'diagram': 'Diagram',
    'clear': 'Clear',
    'operation': 'Operation',
    'add_param': 'Add Param',
    'edit_param': 'Edit Param',
    'value': 'Values',
    'query': 'Query',

    'table_column': 'Table Column',
    'search_table_column': 'Search Table Column',
    'column': 'Column',
    'add_table_column': 'Add Table Column',
    'edit_table_column': 'Edit Table Column',
    'choose_column': 'Choose Column',
    'script': 'Script',
    'search_script': 'Search Script',
    'script_code': 'Script Code',
    'script_description': 'Script Description',
    'add_script': 'Add Script',
    'script_action': 'Script Action',
    'edit_script': 'Edit Script',

    'kpi_report': 'KPI Report',
    'export_as_excel': 'Export as Excel',
    'day': 'Day',
    'month': 'Month',
    'year': 'Year',

    'check_duplicate_by_description': 'Check Duplicate by Description',
    'material_number': 'Material Number',
    'item_name': 'Item Name',
    'short_description': 'Short Description',
    'material_group': 'Material Group',
    'm_group': 'M Group',
    'uom': 'UOM',
    'cat_status': 'Cat Status',

    'export_work_report': 'Export Work Report',
    'export': 'Export',

    'export_data': 'Export Data',

    'import_table': 'Import Table',
    'file_xlsx': 'File (.xlsx)',
    'import_to': 'Import to',
    'import': 'Import',
    'import_errors': 'Import Errors',
    'row': 'Row',
    'header': 'Header',
    'error_message': 'Error Message',
    'values': 'Values',
    'sheet': 'Sheet',
    'import_history': 'Import History',
    'table_name': 'Table Name',
    'success': 'Success',
    'errors': 'Errors',
    'choose_table': 'Choose Table',
    'choose_data': 'Choose Data',

    'app_auditing': 'App Auditing',
    'auditable_type': 'Auditable Type',
    'no_model_log_in_smartcat': 'No Model Log in SmartCat',
    'this_model_log_has_been_taken_today': 'This model log been taken today',
    'no_transaction_log_in_smartcat': 'No Transaction Log in SmartCat',
    'this_transaction_log_has_been_taken_today': 'This Transaction log been taken today',
    'no_activity_log_in_smartcat': 'No Activity Log in SmartCat',
    'this_activity_log_has_been_taken_today': 'This Activity log been taken today',
    'log_code': 'Log Code',
    'log_type': 'Log Type',
    'log_key': 'Log Key',
    'ip': 'IP',
    'user_agent': 'User Agent',
    'executed_by': 'Executed By',
    'result': 'Result',
    'model_log': 'Model Log',
    'transaction_log': 'Transaction Log',
    'search_transaction_log': 'Search Transaction Log',
    'activity_log': 'Activity Log',
    'search_activity_log': 'Search Activity Log',
    'event': 'Event',
    'auditable_id': 'Auditable ID',
    'old_values': 'Old Values',
    'new_values': 'New Values',
    'id': 'ID',
    'user': 'User',
    'method': 'Method',
    'log': 'Log',

    'my_profile': 'My Profile',
    'change_photo': 'Change Photo',
    'change_password': 'Change Password',
    'profile_photo': 'Profile Photo',

    'current_password': 'Current Password',
    'new_password': 'New Password',
    'confirm_new_password': 'Confirm New Password',

    'to_do': 'To Do',
    'your_target': 'Your Target',
    'item': 'Item',
    'cataloged': 'Cataloged',
    'under_target': 'Under Target',
    'rejected': 'Rejected',
    'good_job': 'Good Job',
    'not_good': 'Not Good',
    'processing': 'Processing',
    'mcr_on_process': 'MCR On Process',
    'rejected_mcr': 'Rejected MCR',
    'approved_mcr': 'Approved MCR',
    'total': 'Total',
    'total_mcr': 'Total MCR',
    'detail_kpi_cataloger': 'Detail KPI Cataloger',
    'monitoring': 'Monitoring',
    'users': 'Users',
    'users_status': 'Users Status',
    'summary': 'Summary',
    'catalog_status': 'Catalog Status',
    'count': 'Count',
    'material_catalog_request': 'Material Catalog Request',
    'overview': 'Overview',
    'cataloged_material': 'Cataloged Material',

    'my_notifications': 'My Notifications',

    'advance_search_material': 'ADVANCE SEARCH MATERIAL',
    'manufacture_refference': 'Manufacture Reference',
    'manufacture_ref': 'Manufacture Ref',
    'equipment_code': 'Equipment Code',
    'keyword': 'Keyword',
    'up_keyword': 'KEYWORD',
    'nato_group_class': 'Nato Group Class',
    'valuation_class': 'Valuation Class',
    'val_class': 'Val Class',
    'stock_type': 'Stock Type',
    'long_description': 'Long Description',
    'up_long_description': 'LONG DESCRIPTION',
    'plant': 'Plant',
    'location': 'Location',
    'shelf': 'Shelf',
    'bin': 'Bin',
    'yyyy_mm_dd': 'YYYY-MM-DD',
    'updated_by': 'Updated By',
    'status_report': 'Status Report',

    'unit_of_measure': 'Unit of Measure',
    'search': 'Search',
    'item_type': 'Item Type',
    'group_class': 'Group Class',
    'group_class_or_material_group': 'Group Class/Material Group',
    'product_hierarchy': 'Product Hierarchy',
    'industry_sector': 'Industry Sector',
    'characteristics': 'Characteristics',
    'abc_indicator': 'ABC Indicator',
    'search_abc_indicator': 'Search ABC Indicator',
    'old_material_number': 'Old Material Number',
    'up_old_material_number': 'OLD MATERIAL NUMBER',
    'ext_material_group': 'Ext Material Group',

    'mpn_number': 'Mpn Number',
    'mancode': 'Mancode',
    'manref_description': 'Manref Description',
    'valid_from': 'Valid From',
    'valid_until': 'Valid Until',
    'notes': 'Notes',
    'profit_center': 'Profit Center',
    'plant_sp': 'Plant SP',
    'storage_location': 'Storage Location',
    'equipment': 'Equipment',
    'up_equipment': 'EQUIPMENT',
    'qty_installed': 'Qty Installed',
    'accounting': 'Accounting',
    'up_accounting': 'ACCOUNTING',
    'price_control': 'Price Control',
    'price_ctrl': 'Price Ctrl',
    'std_price': 'STD Price',
    'price_unit': 'Price Unit',
    'po_text': 'PO TEXT',
    'attachment_pdf': 'ATTACHMENT PDF',
    'created_at': 'Created At',
    'attachment_web': 'ATTACHMENT WEB',
    'web_link': 'Web Link',
    'mat_no': 'Mat No',
    'source_description': 'Source Description',
    'tolong_diperbaiki': 'Tolong Diperbaiki',
    'reject': 'Reject',
    'cat_status_change_log': 'Cat Status Change Log',
    'updated_at': 'Updated At',
    'manufacture': 'Manufacture',
    'manufacture_refference_max_40': 'Manufacture Refference (Max 40)',
    'manref_type': 'Manref Type',
    'note': 'Note',
    'plant_code': 'Plant Code',
    'location_code': 'Location Code',
    'add_new_manufacture': 'Add New Manufacture',
    'add_new_plant': 'Add New Plant',
    'add_new_storage_location': 'Add New Storage Location',
    'add_new_equipment': 'Add New Equipment',
    'add_new_sub_menu': 'Add New Sub Menu',
    'update_sub_menu': 'Update Sub Menu',
    'quantity_installed': 'Quantity Installed',
    'standard_price': 'Standard Price',
    'std_price': 'Std Price',
    'add_new_accounting': 'Add New Accounting',
    'add_new_keyword': 'Add New Keyword',
    'add_new_pdf': 'Add New Pdf',
    'add_new_web_link': 'Add New Web Link',
    'pdf_file': 'PDF File',
    'update_new_role': 'Update New Role',

    'service_number': 'Service Number',
    'service_category': 'Service Category',
    'service_group': 'Service Group',
    'serv_no': 'Serv No',
    'category': 'Category',
    'group': 'Group',

    'sap_sync': 'SAP Sync',

    'search_by_characteristic_value': 'Search By Characteristic Value',
    'search_by_characteristic_and_value': 'Search By Characteristic & Value',
    'search_inc': 'Search INC / Item Name',
    'inc_or_item_name': 'INC / Item Name',

    'page_info': ':size of :total',

    'basic_data_classification': 'BASIC DATA & CLASS',
    'plant_sloc': 'PLANT & SLOC',
    'plant_storage_location': 'PLANT & STORAGE LOCATION',
    'purchasing': 'Purchasing',
    'planned_delivery': 'Planned Delivery',
    'planned_delivery_days': 'Planned Delivery (Days)',
    'up_purchasing': 'PURCHASING',
    'up_costing': 'COSTING',
    'keyword_old_number': 'KEYWORD & OLD NO',
    'basic_data': 'BASIC DATA',
    'classification': 'CLASSIFICATION',
    'manufacturer': 'MANUFACTURER',

    'fab_non_fab': 'Fabrication/Non Fabrication',
    'bom_non_bom': 'BOM/Non BOM',
    'crit_non_crit': 'Critical/Non Critical',
    'internal_note': 'Internal Note',
    'mpn_description': 'MPN Description',
    'mpn_desc': 'MPN Desc',
    'valid_to': 'Valid To',
    'purchase_order_text': 'PURCHASE ORDER TEXT',
    'bin_location': 'Bin Location',
    'bin_loc': 'Bin Loc',
    'stock_on_hand': 'Stock On Hand',
    'order_unit': 'Order Unit',
    'no_image_selected': 'No Image Selected',
    'manufacturer_reference': 'Manufacturer Reference',
    'total_item_mcr': 'Total Item MCR',
    'on_process': 'On Process',
    'all_company_code': 'All Company Code',
    'kpi_mcr_approval': 'KPI MCR Approval',
    'check_duplicate_by_part_number': 'Check Duplicate by Part Number',
    'please_complete_data': 'Please complete data :title',
    'invalid_data': "Invalid data :title",
    "material_type_must_be_ZFP_ZPM_or_ZSFG": "Material type must be ZFP, ZPM or ZSFG",
    'please_complete_mandatory_field': 'Please complete all mandatory field',
    'kpi_mcr_creation': 'KPI MCR Creation',
    'new': 'New',
    'all_materials': 'All Materials',
    'spare_parts': 'Spare Parts',
    'fast_moving': 'Fast Moving',
    'others': 'Others',
    'task_tickets': 'Task Tickets',
    'waiting': 'Waiting',
    'closed': 'Closed',
    'count_days': 'Count Days',
    'assigned_date': 'Assigned Date',
    'deadline': 'Deadline',
    'approval_duration': 'Approval Duration',
    'next_approver': 'Next Approver',
    'due_date': 'Due Date',
    'action': 'Action',
    'process': 'Process',
    'resend': 'Resend',
    'revise': 'Revise',
    'status_process': 'Status Process',
    'add_new_mcr_item_again': 'Do you want to create new item again?',
    'show': 'Show',
    'show_as_potext': 'Show as PO TEXT',
    'refresh': 'Refresh',
    'material_consolidation': 'Material Consolidation',
    'material_from': 'Material From',
    'plant_from': 'Plant From',
    'material_to': 'Material To',
    'plant_to': 'Plant To',
    'konsolidasi_material': 'Konsolidasi Material',
    'choose_drawing_master': 'Choose Drawing Master',
    'minimum_type_char': 'Type min :total character',
    'import_mcr_item': 'Import MCR Item',
    'mcr_item_code': 'MCR Item Code',
    'material_number_from': 'Matnum From',
    'material_number_to': 'Matnum To',
    'plant_code_from': 'Plant From',
    'plant_code_to': 'Plant To',
    'del_reason': 'Del Reason',
    'preview_description': 'Preview Description',
    'price_reference': 'Price Reference',
    'price_ref': 'Price Ref',
    'deletion_level': 'Deletion Level',
    'del_flag': 'Del Flag',
    'minimum_stock_old': 'Maximum Stock Old',
    'maximum_stock_old': 'Minimum Stock Old',
    'minimum_stock_new': 'Maximum Stock New',
    'maximum_stock_new': 'Minimum Stock New',
    'revised': 'Revised',
    'total_create': 'Create',
    'total_change': 'Change',
    'total_extend': 'Extend',
    'total_deletion': 'Deletion',
    'total_master_cataloguing': 'Create & Edit Master',
    'total_konsolidation': 'Consolidation',
    'copy_link': 'Copy Link',
    'link': 'Link',
    'attachment_link': 'Attachment Link',
    'overhead_group': 'OverHead Group',
    'costing_lot_size': 'Costing Lot Size',
    'with_qty_structure': 'With Qty Structure',
    'costing': 'Costing',
    'send_password_reset_link': 'Send Password Reset Link',
    'back_to_login': 'Back to Login',
    'error_email_required': 'Email Required',
    'search_mcr_item': 'Search MCR Item',
    'safety_stock': 'Safety Stock',
    'avail_check': 'Avail Check',
    'choose_avail_check': 'Choose Avail Check',
    'sloc_for_ep': 'Sloc For EP',
    'quality_management': 'Quality Management',
    'up_quality_management': 'QUALITY MANAGEMENT',
    'inspection_type': 'Inspection Type',
    'qm_material_auth': 'QM Material Auth',
    'change_log': 'Change Log',
    'log': 'Log',
    'changed_by': 'Changed by',
    'mcr_process' : 'MCR Process',
    'no_mcr' : 'NO MCR',
    'type_mcr' : 'Type MCR',
    'requested_at' : 'Requested At',
    'approved_at' : 'Approved At',
    'total_duration' : 'Total Duration',
    'no_item' : 'NO Item',
    'cataloged_by' : 'Cataloged By',
    'konsolidasi_report' : 'Konsolidasi Report',
    'storage_bin_from' : 'Storage Bin From',
    'unrestricted_stok_from' : 'Unrestricted Stok From',
    'unit_price_from' : 'Unit Price From',
    'storage_bin_to' : 'Storage Bin To',
    'unrestricted_stok_to' : 'Unrestricted Stok To',
    'unit_price_to' : 'Unit Price To',
    'entry_date' : 'Entry Date',
    'posting_date' : 'Posting Date',
    'material_document' : 'Material Document',
    'mrp_controller_&_lot_size' : 'MRP Controller & Lot Size',
    'mrp_controller_lot_size_reorder_point_&_max_stock' : 'MRP Controller, Lot Size, Reorder Point, & Max Stock',
    'status_sap' : 'Status SAP',
    'form' : 'Form',
    'form_code' : 'Form Code',
    'form_description' : 'Form Description',
    'form_type' : 'Form Type',
    'convertion_unit': 'Convertion Unit',
    'extend_to_plant': 'Extend to Plant',
    'extend_to_sloc': 'Extend to Storage Location',
    'rename_folder': 'Rename Folder',
    'confirm_replaced_data': 'If you change the Material Number, all existing data will be changed and replaced?',
    'move_here': 'Move Here',
    'switch_account': 'Switch Account',
    'approval_status': 'Approval Status',
    'line': 'Line',

    'settings' : 'Settings',
    'criticality' : 'Criticality',
    'lead_time' : 'Lead Time',
    'sum_of_process' : 'Sum of Process',
    'int_lead_time' : 'Int Lead Time',
    'avg_lead_time' : 'Avg Lead Time',
    'ext_lead_time' : 'Ext Lead Time',
    'total_lead_time_d' : 'Total Lead Time(d)',
    'total_lead_time_m': 'Total Lead Time(m)',
    'availibility' : 'Availibility',
    'avg_unit_price' : 'Avg Unit Price',
    'unit_price' : 'Unit Price',
    'price' : 'Price',
    'currency' : 'Currency',
    'years':'Years',
    'usage_rate_month' : 'Usage Rate Month',
    'usage_analysis': 'Usage Analysis',
    'abc_analysis' : 'ABC Analysis',
    'kebijakan_persediaan': 'Kebijakan Persediaan',
    'abc_criteria' : 'ABC Criteria',
    'soh':'SOH',
    'sum_of_qty':'Sum of QTY',
    'annual_usage_price' : 'Annual Usage Price',
    'z' : 'Z',
    'avg_demand': 'Avg Demand',
    'avg_lt' : 'Avg LT',
    'std' :'STD',
    'stl' :'STL',
    'safety_stock_value': 'Safety Stock Value',
    'rop' : 'ROP',
    'annual_demand':'Annual Demand',
    'k':'K',
    'i':'i',
    'unit_cost':'Unit Cost',
    'roq':'ROQ',
    'eoq':'EOQ',
    'avg_inventory':'Average Inventory',
    'peak_inventory':'Peak Inventory',

    'config_sap_sync' : 'Config Sap Sync',
    'sync_name' : 'Sync Name',
    'function_type' : 'Function Type',
    'function_source_type' : 'Function Source Type',
    'last_sync_by' : 'Last Sync By',
    'last_sync_at' : 'Last Sync At',
    'search_config_sap_sync' : 'Search Config Sap Sync',

    'params' : 'Params',
    
    'sap_sync_id' : 'Sap Sync Id',
    'param_type' : 'Param Type',
    'data_type'  : 'Data Type',
    'source_type' : 'Source Type',
    'source' : 'Source',
    'source_key': 'Source Key',
    'sap_ref' : 'Sap Ref',
    'sap_key' : 'Sap Key',

    'search_sap_sync_params' : 'Search Sap Sync Params',
    'add_sap_sync_param' : 'Add Sap Sync Param',
    'edit_sap_sync_param' : 'Edit Sap Sync Param',
    'sap_sync_params' : 'Sap Sync Params',
    'mapping' : 'Mapping',
    'sap_sync_param_mapping':'Sap Sync Param Mapping',
    'sap_column' :'Sap Column',
    'source_column' :'Source Column',
    'add_sap_sync' : 'Add Sap Sync',
    'edit_sap_sync' : 'Edit Sap Sync',

    'uom_conversion': 'UoM Conversion',
    'alternative_unit': 'Alternative Unit',
    'base_unit': 'Base Unit',
    'au': 'AU',
    'bu': 'BU',
    'mat_code_created' : 'MAT CODE CREATED',
    'old_abc_indicator' : 'Old ABC Indicator',
    'current_stock' : 'Current Stock',
    'last_inventory_value': 'Last Inventory Value',
    'gi' : 'GI',
    'total_gi' : 'Total GI',
    'new_abc_indicator' : 'New ABC Indicator',
    'abc_evaluation' : 'ABC Evaluation',

    'release' : 'Release',
    'old'     : 'Old',

    'simple_search_material' : 'Simple Search Material',
    'long_description_/_keyword' : 'Long Description / Keyword',

    'material_number_example' : 'Material Number (ex: 6211469)',
    'company_example': 'Company (ex: Pupuk Indonesia)',
    'mcr_number_example': 'MCR Number (ex: MCR211000015)',
    'item_name_example' : 'Item Name (ex: BEARING)',
    'nato_group_class_example': 'Nato Group Class (ex: 3100)',
    'material_type_example': 'Material Type (ex: ZFP)',
    'material_group_example': 'Material Group (ex: 1900)',
    'manufacture_code_example': 'Manufacture Code (ex: SKF BEARINGS)',
    'manufacture_reference_example': 'Manufacture Reference (ex: H322)',
    'plant_example': 'Plant (ex: BA66)',
    'location_example': 'Location (ex: ALUM TANK GS)',
    'equipment_example' : 'Equipment (ex: AH-1000)',
    'scope_of_supply_example' : 'Scope of Supply (ex: 014 - Phos Acid)',
    'uom_example': 'UOM (ex: EA - each)',
    'catalog_status_example': 'Catalog Status (ex: SAP)',
    'catalog_type_example': 'Catalog Type (ex: A01)',
    'updated_by_example': 'Updated By (ex: Ahmad)',
    'short_description_example' : 'Short Description (ex: BEARING)',
    'long_description_example' : 'Long Description (ex: BEARING)',
    'keyword_example': 'Keyword (ex: BALL VALE 3WAY)',

    'long_description_keyword_example' : 'Long Description /Keyword (ex: BEARING)',
    'mcr_report'  : 'MCR Report',
    'assigned_date' : 'Assigned Date',
    'executed_date' : 'Executed Date',

    'material_or_service' : 'Material or Service',
    'choose_material_or_service' : 'Choose Material or Service',

    'part_name' : 'Part Name',
    'description_specification' : 'Description & Specification',
    'failure_mode' : 'Failure Mode',
    'mce_strategy_interval' : 'Mce.Strategy & Interval (+net PF)',
    'mce_strategy' : 'Mce.Strategy',
    // 'mce_interval' : 'Interval (+net PF)',
    'mce_interval' : 'Interval',

    // 'effect_spare_part_not_available' : 'Effect Sparepart Not Available',
    'effect_spare_part_not_available' : 'SOE (Stock Out Effect)',
    'action_to_handle' :'Action to Handle',

    'consequences_criticality':'Consequences & Criticality',
    // 'estimated_loss_idr' : 'Estimated Loss IDR (Unit Time?)',
    'estimated_loss_idr' : 'Estimated Loss (IDR)',
    // 'estimated_lead_time' : 'Estimated Lead Time',
    'estimated_lead_time' : 'Lead Time (Month)',
    'resume_justification_stock_strategy' : 'Resume Justification Stock Strategy',

    // 'original_stock_strategy' : 'Original Stock Strategy',
    'original_mrp_type' : 'Original',
    'stock_strategy' : 'Stock Strategy',
    'reference' : 'Reference',

    'choose_original_stock_strategy' : 'Choose Original Stock Strategy',
    'choose_stock_strategy' : 'Choose Stock Strategy',

    'choose' : 'Choose',
    'interval' : 'Interval',
    'drawing_part_number' : 'Drawing / Part Number',

    'requestor' : 'Requestor',
    'consolidation_type': 'Consolidation Type',

    'shp' : 'SHP',
    'receiver' : 'Receiver',
    'choose_receiver' : 'Choose Receiver',
    'warehouse_management' : 'Warehouse Management',
    'up_warehouse_management' : 'WAREHOUSE MANAGEMENT',
    'warehouse_management_1' : 'Warehouse Management 1',
    'warehouse_management_2' : 'Warehouse Management 2',

    'stock_removal' : 'Stock Removal',
    'stock_replacement' : 'Stock Replacement',
    'storage_location_ind' : 'Storage Location Ind',

    'warehouse_number' : 'Warehouse Number',
    'storage_bin' : 'Storage Bin',

    'storage_type' : 'Storage Type',
    'storage_section' : 'Storage Section',

    'storage_section_indicator' : 'Storage Section Indicator',
    'storage_type_indicator' : 'Storage Type Indicator',

    'duplicate_condition' : 'Duplicate Condition',
    'workflow_code' : 'Workflow Code',

    'equipment_&_material_number' : 'Equipment & Material Number',
    'stock_holding_policy' : 'Stock Holding Policy',
    'confirm_replace': 'Are you sure to replace this data?',

    'item_type_example' : 'Item Type (ex: GEN)' ,
    'demand_rate'       : 'Demand Rate',
    'mandatory_field_*' : 'Mandatory Field (*)',
    'next_approver'     : 'Next Approver',
    'log_approval'      : 'Log Approval',

    'stock_level_type_calculation' : 'Stock Level Type Calculation',
    'service_level' :'Service Level (%)',
    'shortdes' : 'shortdes',
    'sloc_soh': 'SLOC & SOH',
    'unit' : 'Unit',
    'qty_sku' : 'Qty SKU',
    'qty' : 'Quantity',
    'reorder_point_greater_than_max_stock': 'Reorder Point Must Less Than or Equal to Max Stock',
    'price_unit_than_5' : 'Length Price Unit Must Less Than or Equal to 5 Digit',
    'order_cost':'Order Cost',
    'initial_inventory' : 'Initial Inventory',
    'annual_carrying_cost' : 'Annual Carrying Cost',

    'choose_uom' : 'Choose the UoM',
    'type_the_quantity' : 'the Type of Quantity',
    'mce_net_pf' : 'Net PF (Month)',
    'mce_tindakan' : 'Action',
    'estimated_loss_day' : 'Estimated Loss (day)',
    'total_estimated_loss' : 'Total Estimated Loss (IDR)',
    'choose_consequences_criticality' : 'Choose the Consequences and Criticality',
    'quantity_on_hand' : 'Quantity on Hand',
    'value_unrestricted' : 'Value Unrestricted',
    'category_lead_time' : 'Category Lead Time',
    'choose_category_lead_time' : 'Choose Category Lead Time',
    'after_analysis_mrp_type' : 'After Analysis',
    'change_mrp_type' : 'Change MRP Type',
    'choose_original_mrp_type' : 'Choose Original MRP Type',
    'choose_after_analysis_mrp_type' : 'Choose After Analysis MRP Type',
    'change_mrp_type' : 'Has the MRP Type changed?',
    'original_stock_level_type_calculation' : 'Stock Level Type Calculation (Original)',
    'after_analysis_stock_level_type_calculation' : 'Stock Level Type Calculation (After Analysis)',
    'original_service_level' : 'Service Level (Original)',
    'after_analysis_service_level' : 'Service Level (After Analysis)',
    'stock_level' : 'Stock Level',
    'original_stock_level' : 'Stock Level (Original)',
    'after_analysis_stock_level' : 'Stock Level (After Analysis)',
    'original_min' : 'Min (Original)',
    'after_analysis_min' : 'Min (After Analysis)',
    'original_max' : 'Max (Original)',
    'after_analysis_max' : 'Max (After Analysis)',
    'date_during_analysis' : 'Date during Analysis',
    'shp_min' : 'Min',
    'shp_max' : 'Max',

    'sap_import_table' : 'SAP Import Table',
    'imported_file' : 'Imported File',
    'imported_by' : 'Imported by',
    'date_import' : 'Date of Import',
    'number_lines' : 'Number of Data',
    'number_errors' : 'Number of Errors',
    'finished' : 'Finish',
    'stopped' : 'Pending',
    'form_import' : 'Form Import',
    'back' : 'Back',
    'next' : 'Next',
    'start' : 'Start',
    'diproses' : 'Successfully Processed',
    'jumlah_gagal' : 'Number of Failures',
    'jumlah_sukses' : 'Number of Successes',
    'baris_data' : ' Lines of Data',
    'detail_data_import' : 'Detail Data Import',
    'error_data_history' : 'Error History',
    'tanggal_diproses' : 'Processing Date',
    'input_excel' : 'Input Excel',
    'inputFile_text' : 'You must to input the Excel file that will be the source of data.',
    'startImport_text' : 'We have gathered all the information from the Excel file you inputted. Press the Start button to begin importing.',
    'detailImportLog_text' : 'Here are the Excel import details after the integration process into SAP.',
    'import_type' : 'Import Type',
    'append' : 'Append',
    'update_or_append' : 'Update or Append',
    'shp_exists' : 'SHP Exists',
    'detail_import_log' : 'Detail Import',
    'material_cataloguing' : 'Material Cataloguing',
    'please_complete_data_excel_mcr_shp': 'Please complete data material number or equipment code.',
    'class' : 'Class',
    'download_excel_template_sap_import' : "Don't have the template yet? Click here!",

    'status_sap' : 'Status SAP',
    'confirm_uom_mirroring' : 'The UoM you selected is different from the UoM on the MCR form. Do you want to continue?',
    'cbm_and_net_pf' : "there is a 'CBM' strategy but the NET PF is empty.",
    'meeting_for_this_material' : 'Need meeting for this material ?',
    'material_has_been_discussed' : 'Has this material been discussed ?',
    'material_date_discussion' : 'Date Discussion',
    'owner_estimate' : 'Owner Estimate',
    'confirm_owner_estimate' : 'Are you sure the field owner estimate remains 0?',
    'up_duplicate_material' : 'DUPLICATE MATERIAL',
    'duplicate_material' : 'Duplicate Material',
    'mcr_type' : 'MCR Type ',
    'choose_mcr_type' : 'Choose MCR Type',
    'consumable_notification' : 'Your MCR is consumable so filling the SHP form is not required',
    'suku_cadang_penyangga_and_not_applicable_notification' : 'Your MCR is not consumable so filling the SHP form is required',
    'consumable' : 'Consumable',
    'suku_cadang_penyangga' : 'SCP (Suku Cadang Penyangga)',
    'suku_cadang' : 'Suku Cadang',
    'not_applicable' : "Suku Cadang Non SCP",
    'please_complete_shp_form_data' : `Because your MCR Type is either NCP or N/A, the SHP form must be filled in. Please complete :title`,

    'material_duplication' : "Material Duplication",
    'search_material_duplication' : "Search Material Duplication",
    'detail_duplication' : "Detail Duplication",
    'material_number_dupl' : "Matnum",
    'short_text' : 'Short Text',
    'plant_name' : 'Plant Name',
    'repair_time': 'Repair Time',
    'repairable_non_repairable': 'Repairable/Non Repairable',
    'duration': 'Duration',
    'priority_level': 'Level Priority',
    'choose_priority_level': 'Choose Level Priority',
    'all': 'All',
    'Sangat Segera': 'Critical',
    'Segera': 'Urgent',
    'Biasa': 'Normal',
    'warehouse_management': 'Warehouse Management',
    'form_date': 'From Date',
    'to_date': 'To Date',
    'max_10_bln_range_export': 'The maximum date range is 10 months.',
    'abbreviation': 'Abbreviation',
    'Abbreviation in line item ': 'Abbreviation in line item ',
    ' is required': ' is required!',
    'tomat_search': 'TOMAT Search',
    'plant_example_2': 'Plant (ex: C601)',
    'UOM': 'UOM',
    'unrestricted_used': 'Unrestricted Used',
    'last_update': 'Last Update',
    'detail_import_data': 'Detail Import Data',
    'send_to_sap': 'Send to SAP',
    'ex_po_text': 'EX PO TEXT',
    'new_po_text': 'NEW PO TEXT (HARMONISASI',
    'logs': 'Logs',
    'latest_po_text_sap': 'Latest PO Text SAP',
    'po_text_toms': 'PO Text TOMS',
    'Data are being processed for SAP upload': 'Data are being processed for SAP upload.',
    'review': 'Review',
    'harmonisasi_date': 'Harmonisasi Data Import',
    'latest_po_text_sap_date': 'Latest PO Text SAP Date',
    'short_text_ex': 'ex short text',
    'short_text_new': 'new short (harmonisasi)',
    'login_as': 'Login as User',
    'impersonate_confirmation': 'Login as <b>:username</b> (:name) ?',
    'impersonate_banner_success': 'You are impersonating :name',
    'impersonate_mode_active': 'You are currently in impersonate mode as',
    'exit_impersonate': 'Exit Impersonate Mode'
}